module.exports = __webpack_public_path__ + "static/media/klassische-massage-desktop.191df761.jpg";